import { useDisclosure } from '@chakra-ui/hooks';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Icon,
  IconButtonProps,
} from '@chakra-ui/react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { EmojiData } from 'emoji-mart';
import { FC } from 'react';

import EmojiIcon from '@/assets/icons/ic-emoji.svg';

interface IChatEmojiPickerProps extends Partial<IconButtonProps> {
  onEmojiSelect: (emoji: EmojiData) => void;
}

export const NewChatEmojiPicker: FC<IChatEmojiPickerProps> = ({ onEmojiSelect, ...props }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();

  function handleEmojiSelect(emoji: EmojiData) {
    onClose();
    onEmojiSelect(emoji);
  }

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="top-end" offset={[50, 20]} isLazy>
      <PopoverTrigger>
        <IconButton
          variant="link"
          colorScheme="violet"
          aria-label="emoji popup"
          alignSelf="center"
          maxW="min-content"
          minW="max-content"
          onClick={onToggle}
          {...props}
        >
          <Icon w="24px" h="24px" color="violet.500" as={EmojiIcon} />
        </IconButton>
      </PopoverTrigger>
      <PopoverContent w="full" borderWidth={1} borderRadius="xl">
        <PopoverBody p={0}>
          <Picker theme="light" perLine={8} data={data} onEmojiSelect={handleEmojiSelect} />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
